import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createMaster, getMasterList } from "reduxStore/action/masterActions";
import { removeModalClass } from "utils/modalHandler";
import strings from "translate/language";
import { errorToast, successToast } from "utils/httpClient";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import TableDataNotFound from "component/TableDataNotFound";
import Button from "../../component/Button";
import usePermission from "utils/usePermission";
import { MasterType } from "utils/constants";

const Master = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "",
    type: "",
    _id: "",
    status: "",
    search_name: "",
  });
  const [formVaild, setFormVaild] = useState(false);
  const [masterData, setMasterData] = useState([]);
  // const [masterUpdate, setMasterUpdate] = useState([]);

  const { create, edit } = usePermission({
    create: "add_master",
    edit: "edit_master",
  });

  const filterDetail = () => {
    dispatch(
      getMasterList({
        type: form.type,
        search_name: form.search_name,
      })
    );
  };
  const filterReset = () => {
    setForm({
      type: "",
      search_name: "",
    });
    dispatch(getMasterList());
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const dispatch = useDispatch();
  const masterListSelector = useSelector((state) => state.masterData) || [];

  useEffect(() => {
    dispatch(getMasterList());
  }, []);
  useEffect(() => {
    if (masterListSelector?.create === true) {
      if (masterListSelector?.response?.status === 200) {
        setForm({ type: "", title: "", status: "" });
        dispatch(getMasterList());
        successToast(masterListSelector?.response?.message);
      } else {
        errorToast(masterListSelector?.response?.message);
      }
    } else {
      if (masterListSelector?.response?.status === 200) {
        if (masterListSelector?.response?.data.length > 0) {
          setMasterData(
            handleListResponse(masterListSelector?.response?.data)
              ? masterListSelector?.response?.data
              : []
          );
        } else {
          setMasterData([]);
          // errorToast(masterData.response.message);
        }
      }
    }
  }, [masterListSelector]);

  const getMaster = (id = "") => {
    setFormVaild(false);
    const filtered = masterData.filter((i) => i._id === id);
    if (filtered.length) {
      setForm({
        master_id: id,
        title: filtered[0].title,
        type: filtered[0].type,
        status: filtered[0].status ? "Active" : "Deactive",
      });
    }
    document.getElementById("submitmodal").textContent = strings.update;
  };

  const handleSubmit = () => {
    if (form.title === "") {
      setFormVaild(true);

      return true;
    } else {
      removeModalClass("exampleModal");
      setFormVaild(false);
      form.status = form.status === "Active" ? true : false;
      dispatch(createMaster(form));
    }
  };
  useEffect(() => {
    seo({
      title: "Master Listing",
      metaDescription: "Master listing",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      {/*add_module_start */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.master}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <label htmlFor="exampleFormControlSelect9">
                {strings.typeOfMaster}
              </label>

              <select
                className="form-control digits"
                id="exampleFormControlSelect9"
                name="type"
                value={form.type}
                onChange={handleInputField}
              >
                <option defaultValue={true}>{strings.selectType}</option>
                {Object.entries(MasterType).map(
                  ([key, value], index) =>
                    Number(key) !== Number(0) && (
                      Number(key) !== Number(1) && (
                        Number(key) !== Number(2) && (
                          <option key={index} value={key}>
                          {value}
                          </option>
                        )
                      )
                    )
                )}
              </select>
            </div>
            <div className="modal-body">
              <label htmlFor="exampleFormControlSelect9">{strings.title}</label>
              <span className="required-field"></span>
              <input
                className="form-control"
                id="exampleFormControlFirstName"
                type="text"
                placeholder={strings.title}
                name="title"
                value={form.title}
                onChange={handleInputField}
              />
              {formVaild && (
                <span style={{ color: "red" }}>{strings.titleisrequired}</span>
              )}
            </div>
            <div className="modal-body">
              <label htmlFor="exampleFormControlSelect9">
                {strings.status}
              </label>

              <select
                className="form-control digits"
                id="exampleFormControlSelect9"
                name="status"
                value={form.status}
                onChange={handleInputField}
              >
                <option defaultValue={true}>{strings.selectstatus}</option>
                <option value={"Active"}>{strings.active}</option>
                <option value={"Deactive"}>{strings.deactive}</option>
              </select>
            </div>
            <div
              className="modal-footer"
              style={{ justifyContent: "space-between" }}
            >
              <Button
                className="btn btn-dark"
                dataDismiss="modal"
                label={strings.back}
              ></Button>
              <Button
                className="btn btn-color"
                id="submitmodal"
                onClick={() => handleSubmit()}
                label={strings.submit}
              ></Button>
            </div>
          </div>
        </div>
      </div>
      {/* add_module_end */}
      <Breadcrumb title={strings.master} titleactive={strings.masterListing} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">
                            {" "}
                            {strings.searchByTitle}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="search_name"
                              value={form.search_name}
                              onChange={handleInputField}
                              placeholder={strings.searchTitle}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByType}
                          </span>

                          <select
                            className="form-control digits"
                            id="exampleFormControlSelect9"
                            name="type"
                            value={form.type}
                            onChange={handleInputField}
                          >
                            <option defaultValue={true}>
                              {strings.selectType}
                            </option>
                            {Object.entries(MasterType).map(
                              ([key, value], index) =>
                                Number(key) !== Number(0) && (
                                  <option key={index} value={key}>
                                    {value}
                                  </option>
                                )
                            )}
                          </select>
                        </div>
                        <div className="col-md-4 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <Button
                              className="btn btn-warning mr-4"
                              onClick={filterDetail}
                              label={strings.search}
                            ></Button>
                            <Button
                              className="btn btn-dark"
                              onClick={filterReset}
                              label={strings.reset}
                            ></Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {create && (
              <div className="row pt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <Button
                      dataToggle="modal"
                      dataOriginalTitle="test"
                      dataTarget="#exampleModal"
                      onClick={() => {
                        setForm({ type: "", title: "", status: "" });
                        document.getElementById("submitmodal").textContent =
                          strings.submit;
                      }}
                      label={strings.addNewMaster}
                    ></Button>
                  </div>
                </div>
                <div className="col-md-6 "></div>
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfMaster}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.title}</th>
                          <th scope="col">{strings.type}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {masterData.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className="transform">{item.title}</td>
                              <td>{MasterType[Number(item.type)] }</td>
                              <td>{item.status ? "Active" : "Deactive"}</td>
                              {(edit && (Number(item.type)!==Number(1) && Number(item.type)!==Number(2))) ?(
                                <td>
                                  <Button
                                    className="btn btn-dark"
                                    dataToggle="modal"
                                    dataOriginalTitle="test"
                                    dataTarget="#exampleModal"
                                    onClick={() => getMaster(item._id)}
                                    label={strings.edit}
                                  ></Button>
                                </td>
                              ):"-"}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <TableDataNotFound data={masterData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Master;
